module.exports = __webpack_public_path__ + "3f1060ae.svg";